import { IconPropsType } from '..';

export const LiveSportsIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="general=default, betting=sign-live, statuses=default, arrows=default, toggleables=default, signs=default, menus=default, casino=default, currency=default">
      <path
        id="Vector"
        d="M16.6781 4.33328H3.32206C2.70637 4.33376 2.11604 4.57855 1.68069 5.01391C1.24533 5.44926 1.00054 6.0396 1.00006 6.65528V13.5313C1.00054 14.147 1.24533 14.7373 1.68069 15.1727C2.11604 15.608 2.70637 15.8528 3.32206 15.8533H16.6781C17.2937 15.8528 17.8841 15.608 18.3194 15.1727C18.7548 14.7373 18.9996 14.147 19.0001 13.5313V6.65528C18.9996 6.0396 18.7548 5.44926 18.3194 5.01391C17.8841 4.57855 17.2937 4.33376 16.6781 4.33328ZM5.55946 13.0921H2.31946L3.35806 7.09448H4.54066L3.67306 12.0877H5.73766L5.55946 13.0921ZM7.50886 13.0921H6.32626L7.36846 7.09448H8.56006L7.50886 13.0921ZM9.87046 13.0921L9.14146 7.09448H10.4231L10.7201 11.4325L12.3761 7.09448H13.7243L11.1017 13.0921H9.87046ZM17.5061 8.10248H15.3461L15.0995 9.52088H16.9337L16.7537 10.4965H14.9339L14.6585 12.0877H16.8185L16.6385 13.0921H13.3031L14.3417 7.09448H17.6825L17.5061 8.10248Z"
        fill="current"
      />
    </g>
  </svg>
);
